import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import palette from '../../lib/styles/palette';
import { Link } from 'react-router-dom';
// import { MdAdd } from 'react-icons/md';
import { Helmet } from 'react-helmet-async';
import { conveyorWeightTotal } from '../conveyor-structure/StructureList';
import { toFixedSafe } from '../../lib/styles/perttierNumber';
import classNames from 'classnames';
import { getComponentWeightPerConveyor } from '../conveyor-component/ComponentList';

const ConveyorList = ({
    loading,
    error,
    conveyors,
    onEditStructure,
    // project,
    ownProject,
    // user,
    // showWriteButton,
}) => {
    const typeMap = useRef({
        Troughed: 'TR',
        Pipe: 'PI',
        'Return Pipe': 'RP',
        'Steep Angle': 'ST',
        Sandwitch: 'SW',
    });

    // 에러 발생 시
    if (error) {
        return <ConveyorListBlock>에러가 발생했습니다.</ConveyorListBlock>;
    }

    if (loading || !conveyors) return;

    const editClass = classNames({
        numeric: true,
        edit: ownProject,
    });

    return (
        <ConveyorListBlock>
            <Helmet>
                <title>Conveyor List</title>
            </Helmet>
            <Content>
                <Caption>
                    <h1>Conveyor List</h1>
                </Caption>
                <Table id="table-to-xlsx">
                    <thead>
                        <tr>
                            <th style={{ minWidth: '60px' }}>No.</th>
                            <th>Type</th>
                            <th>Profile</th>
                            <th>
                                H.L
                                <br />
                                (m)
                            </th>
                            <th>
                                V.L
                                <br />
                                (m)
                            </th>
                            <th>
                                Capa.
                                <br />
                                (tph)
                            </th>
                            <th>M'tl</th>
                            <th>
                                Density
                                <br />
                                (kg/m3)
                            </th>
                            <th>
                                Sur-
                                <br />
                                charge
                                <br />
                                (deg.)
                            </th>
                            <th>
                                Belt
                                <br />
                                Width
                                <br />
                                (mm)
                            </th>
                            <th>
                                Speed
                                <br />
                                (m/s)
                            </th>
                            <th>
                                Tractive
                                <br />
                                Pull
                                <br />
                                (N)
                            </th>
                            <th>Drive ID.</th>
                            <th>
                                Drive
                                <br />
                                Eff.
                            </th>
                            <th>
                                Req'd
                                <br />
                                Power
                                <br />
                                (kW)
                            </th>
                            <th>
                                Selected
                                <br />
                                Motor
                                <br />
                                (kW)
                            </th>
                            <th>Poles</th>
                            <th>
                                Wrap
                                <br />
                                Angle
                                <br />
                                (deg.)
                            </th>
                            <th>
                                Lagging
                                <br />
                                friction
                                <br />
                                coeff.
                            </th>
                            <th>
                                Driving
                                <br />
                                Factor
                            </th>
                            <th>
                                T1
                                <br />
                                (N)
                            </th>
                            <th>
                                T2
                                <br />
                                (N)
                            </th>
                            <th>
                                Max
                                <br />
                                Tension
                                <br />
                                (N)
                            </th>
                            <th>
                                KNW
                                <br />
                                (kN/m)
                            </th>
                            <th>Selected Belt</th>
                            <th>SF</th>
                            <th>
                                Wb
                                <br />
                                (kg/m)
                            </th>
                            <th>
                                Drive
                                <br />
                                Pulley
                                <br />
                                Dia(mm)
                            </th>
                            <th>
                                Fluid
                                <br />
                                Coup.
                            </th>
                            <th>
                                Gear
                                <br />
                                Coup.
                            </th>
                            <th>Brake</th>
                            <th>
                                Hold
                                <br />
                                back
                            </th>
                            <th>
                                Comp.
                                <br />
                                W't
                                <br />
                                (ton)
                            </th>
                            <th>
                                Struct.
                                <br />
                                W't
                                <br />
                                (ton)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveyors.map((conveyor) => (
                            <tr key={conveyor.id}>
                                <td>
                                    <Link to={`/conveyors/${conveyor._id}`}>{conveyor.title}</Link>
                                </td>
                                <td>{typeMap.current[conveyor.conveyorType]}</td>
                                <td className="profile-img">
                                    <Link to={`/conveyors/${conveyor._id}`}>
                                        {conveyor.body.profile?.imgNumber ? (
                                            <img
                                                src={require(`../../images/profile_${conveyor.body.profile?.imgNumber}_without_dimension.png`)}
                                                alt={`profile_${conveyor.body.profile?.imgNumber}_without_dimension.png`}
                                            />
                                        ) : (
                                            <>No Profile Image</>
                                        )}
                                    </Link>
                                </td>
                                <td className="numeric">{conveyor.body.input?.length}</td>
                                <td className="numeric">{conveyor.body.input?.height}</td>
                                <td className="numeric">{conveyor.body.input?.capacity}</td>
                                <td className="text">{conveyor.body.input?.materialConveyed}</td>
                                <td className="numeric">{conveyor.body.input?.specificGravity}</td>
                                <td className="numeric">{conveyor.body.input?.surchargeAngle}</td>
                                <td className="numeric">
                                    <div>{conveyor.body.input?.beltWidth}</div>
                                    {(conveyor.conveyorType === 'Pipe' || conveyor.conveyorType === 'Return Pipe') && (
                                        <div>(𝜙{conveyor.body.input?.pipeDiameter})</div>
                                    )}
                                </td>
                                <td className="numeric">{toFixedSafe(conveyor.body.input?.beltSpeed, 2)}</td>
                                <td className="numeric">{conveyor.body.resistance?.overall?.load}</td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.description?.substr(0, 3)}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{toFixedSafe(drive.mechanicalEfficiency, 2)}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.requiredPower}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.selectedMotor}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.poles}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.wrapAngle}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{toFixedSafe(drive.frictionCoeff, 2)}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{toFixedSafe(drive.drivingFactor, 2)}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.tightSideTension?.load ?? ''}</div>
                                    ))}
                                </td>
                                <td className="numeric">
                                    {conveyor.body.drives?.map((drive, index) => (
                                        <div key={index}>{drive.slackSideTension?.load ?? ''}</div>
                                    ))}
                                </td>
                                <td className="numeric">{conveyor.body.belt?.maxTension}</td>
                                <td className="numeric">{conveyor.body.belt?.unitBeltTension}</td>
                                <td className="text">{conveyor.body.belt?.selectedBelt}</td>
                                <td className="numeric">{toFixedSafe(conveyor.body.belt?.actualBeltSF, 1)}</td>
                                <td className="numeric">{conveyor.body.output?.massBelt}</td>
                                <td className="text">
                                    <div>{getPulleyInfo(conveyor.body.pulleys, '1st Drive', 'diaWithLagging')}</div>
                                    <div>{getPulleyInfo(conveyor.body.pulleys, '2nd Drive', 'diaWithLagging')}</div>
                                </td>
                                <td className="text">
                                    {conveyor.body.fluidCouplings?.map((item, index) => (
                                        <div key={index}>{item.selectedFluidCoupling}</div>
                                    ))}
                                </td>
                                <td className="text">
                                    {conveyor.body.gearCouplings?.map((item, index) => (
                                        <div key={index}>{item.model}</div>
                                    ))}
                                </td>
                                <td className="text">
                                    {conveyor.body.brakes?.map((item, index) => (
                                        <div key={index}>{item.model}</div>
                                    ))}
                                </td>
                                <td className="text">
                                    {conveyor.body.backstops?.map((item, index) => (
                                        <div key={index}>{item.model}</div>
                                    ))}
                                </td>
                                <td className={editClass} onClick={() => {}}>
                                    {getComponentWeightPerConveyor(conveyor)}
                                </td>
                                <td className={editClass} onClick={() => onEditStructure(conveyor)}>
                                    {conveyorWeightTotal(conveyor.body.structure?.summary)
                                        ? conveyorWeightTotal(conveyor.body.structure?.summary)
                                        : '<Edit>'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {conveyors && (
                    <p style={{ fontSize: '0.85rem' }}>
                        TR: Troughed Conveyor / PI: Pipe Conveyor / RP: Return Pipe Conveyor / SA: Steep Angle / SW:
                        Sandwitch{' '}
                    </p>
                )}
            </Content>
        </ConveyorListBlock>
    );
};

export default ConveyorList;
// export default React.meno(ConveyorList);

/* =================   Styles   ================== */
const ConveyorListBlock = styled.div`
    display: flex;
    img {
        width: 100px;
    }
`;

const Content = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Caption = styled.div`
    // display: flex;
    // justify-content: space-between;
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;
    }
`;

const Table = styled.table`
    //overflow-x: auto;   // 테이블을 감싸는 요소에 적용해야 한다.

    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
    text-align: center;
    thead tr th {
        font-weight: 500;
        padding: 0.5rem 0.5rem;
        background: ${palette.gray[2]};
        border-bottom: 2px solid ${palette.gray[4]};
    }
    tbody tr {
        &:nth-child(even) {
            background: ${palette.gray[2]};
        }
    }
    tbody tr td {
        height: 4rem;
        padding: 0.5rem 0.25rem;
        &:hover {
            ${(props) =>
                props.ownProject &&
                css`
                    cursor: pointer;
                `}
        }
    }
    .numeric {
        text-align: right;
    }
    .edit {
        &: hover {
            cursor: pointer;
            color: ${palette.gray[6]};
        }
    }
`;

const getPulleyInfo = (pulleys, application, key) => {
    // key: 가져오려는 값의 key.
    if (!pulleys) return;
    const obj = pulleys.find((pulley) => pulley.application === application);
    if (!obj) {
        return '';
    }
    return obj[key];
};
